import { useQuery } from "@tanstack/react-query";
import { Navigate, Outlet } from "react-router-dom";
import { souAdminDaPlataforma } from "@/features/admin/api/plataforma";

/**
 * Guarda do painel da plataforma.
 *
 * A checagem de verdade está no banco, dentro de cada função. Isto aqui só
 * evita que a rota apareça vazia para quem não é admin: mandar para o
 * atendimento é mais honesto que mostrar uma tela de erro.
 */
export function RotaDeAdmin() {
  const { data: souAdmin, isLoading } = useQuery({
    queryKey: ["sou_admin_plataforma"],
    queryFn: souAdminDaPlataforma,
    staleTime: 10 * 60_000,
  });

  if (isLoading) return null;
  if (!souAdmin) return <Navigate to="/atendimento" replace />;

  return <Outlet />;
}
